import Route from '@ember/routing/route';

export default class BoardIndexLoadingRoute extends Route {}
